// extracted by css-extract-rspack-plugin
export default {"cls1":"MarketingPageLayout-cls1_tAp","cls2":"MarketingPageLayout-cls2_nyo MarketingPageLayout-cls1_tAp"};